import { isSaudiBrand } from '../../../shared/utils/brandCurrency';

/** Legacy Algeria / French accounting elements shown in document creation. */
export const ALGERIAN_TAX_ORDER = [
  'TVA',
  'TAP',
  'Timbre',
  'Remise',
  'Rabais',
  'Escompte',
  'Transport',
  'Retour',
  'Acompte',
  'Avance',
  'Garantie',
  'IRG',
  'IBS',
];

/** ZATCA-aligned document totals: VAT, discount, shipping, payments, retention. */
export const SAUDI_TAX_ORDER = [
  'TVA',
  'Remise',
  'Transport',
  'Retour',
  'Acompte',
  'Avance',
  'Garantie',
];

export const SAUDI_HIDDEN_TAX_ELEMENTS = new Set([
  'TAP',
  'Timbre',
  'Rabais',
  'Escompte',
  'IRG',
  'IBS',
]);

export function getDefaultTaxOrder() {
  return isSaudiBrand() ? [...SAUDI_TAX_ORDER] : [...ALGERIAN_TAX_ORDER];
}

export function sanitizeTaxOrderForBrand(order) {
  const base = Array.isArray(order) && order.length > 0 ? order : getDefaultTaxOrder();
  if (!isSaudiBrand()) return base;
  const filtered = base.filter((el) => !SAUDI_HIDDEN_TAX_ELEMENTS.has(el));
  return filtered.length > 0 ? filtered : [...SAUDI_TAX_ORDER];
}

export function isSaudiHiddenTaxElement(taxElement) {
  return isSaudiBrand() && SAUDI_HIDDEN_TAX_ELEMENTS.has(taxElement);
}

const TAX_LABEL_KEYS = {
  TVA: 'document_creation.form.vat_label',
  Remise: 'document_creation.form.totals_discount',
  Transport: 'document_creation.form.totals_transport',
  Retour: 'document_creation.form.return_cost',
  Acompte: 'document_creation.form.totals_down_payment',
  Avance: 'document_creation.form.totals_advance',
  Garantie: 'document_creation.form.totals_retention',
  Rabais: 'document_creation.form.totals_rebate',
  Escompte: 'document_creation.form.totals_early_discount',
  TAP: 'document_creation.form.totals_tap',
  Timbre: 'document_creation.form.totals_fiscal_stamp',
  IRG: 'document_creation.form.withholding_irg',
  IBS: 'document_creation.form.withholding_ibs',
};

/** Localized checkbox / input label for a tax element. */
export function getTaxElementDisplayLabel(t, taxElement) {
  const key = TAX_LABEL_KEYS[taxElement];
  return key ? t(key) : taxElement;
}
